import React from "react"
import PropTypes from "prop-types"

const Favorites = ({ fillColor, stroke }) => (
  <svg
    width="21"
    height="18"
    viewBox="0 0 16 14"
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.24049 1C6.29867 1 7.33137 2.33333 8.21449 3.66667C9.0976 2.33333 9.83111 1 11.7469 1C14.8378 1 15.3231 3.73508 14.8378 5.44444C13.9546 8.55556 10.4223 11.2222 8.21449 13C6.00671 11.6667 2.03268 8.11111 1.14963 5.44444C0.591135 3.75788 1.59115 1 4.24049 1Z"
      stroke={stroke}
      strokeLinejoin="round"
    />
  </svg>
)

Favorites.propsTypes = {
  fillColor: PropTypes.string,
  stroke: PropTypes.string,
}

Favorites.defaultProps = {
  fillColor: "none",
  stroke: "black",
}

export { Favorites }
